"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simulatePiece = simulatePiece;
const doActions_1 = require("./doActions");
const attack_1 = require("./state/attack");
const dying_1 = require("./state/dying");
const wander_1 = require("./state/wander");
const DYING_DURATION = 10;
const stateFunctions = {
    wandering: wander_1.doWander,
    attacking: attack_1.doAttack,
    dying: dying_1.doDying,
};
/**
 * Get the current state of the piece.
 *
 * Overrides the state of the piece if it's dying.
 */
function getPieceState(currentTurn, piece, { combatStore, eventLog }) {
    const combatState = combatStore.getPiece(piece.id);
    if (combatState.currentHealth === 0 && combatState.state.type !== "dying") {
        const dieAtTurn = currentTurn + DYING_DURATION;
        const newState = {
            type: "dying",
            payload: { dieAtTurn },
        };
        combatStore.updatePiecePartial(piece.id, { state: newState });
        if (eventLog) {
            eventLog.append({ type: "piece_dying", pieceId: piece.id });
        }
        return newState;
    }
    return combatState.state;
}
/**
 * Simulate the turn of a single piece on the board, and return the new board state.
 */
function simulatePiece(currentTurn, board, pieceRegistry, pieceId, stores) {
    const piece = pieceRegistry.getPieceById(pieceId);
    if (!piece) {
        return;
    }
    const state = getPieceState(currentTurn, piece, stores);
    const [newState, actions] = stateFunctions[state.type](currentTurn, state, board, pieceRegistry, pieceId, stores);
    // if there was a new state, set our piece to it
    if (newState !== state) {
        stores.combatStore.updatePiecePartial(piece.id, { state: newState });
    }
    // process any actions
    if (actions) {
        (0, doActions_1.doActions)(currentTurn, board, pieceRegistry, piece.id, actions, stores);
    }
}
